import React from 'react';
import { MotorFlowType, MotorStepType } from 'scenes/motor/types';
import styled from 'styled-components';
import THEME from 'theme';
import { MotorPostQuote } from './MotorPostQuote';
import { MotorPreQuote } from './MotorPreQuote';
import { shouldShowPreQuote } from './utils';

const ProgressFlowBarWrapper = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${THEME.BACKGROUND.CARD};
  padding: 1rem;
  padding-bottom: 1.5rem;
`;

const MotorProgressBarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80px;
`;

interface MotorProgressBarProps {
  flow: MotorFlowType;
  step: MotorStepType;
}

export const DesktopProgressBar = ({ step, flow }: MotorProgressBarProps) => {
  const shouldDisplayPreQuote = shouldShowPreQuote(flow, step);
  return (
    <ProgressFlowBarWrapper>
      <MotorProgressBarWrapper>
        {shouldDisplayPreQuote ? (
          <MotorPreQuote flow={flow} step={step} />
        ) : (
          <MotorPostQuote flow={flow} step={step} />
        )}
      </MotorProgressBarWrapper>
    </ProgressFlowBarWrapper>
  );
};
